import React, { FC } from 'react';

import { IconPropsExtended } from '../types';

import MaterialSymbolIconBase from './MaterialSymbolIconBase';

/**
 * Material symbol calendar outlined icon
 *
 * @param props Props passed to the component
 * @returns     Calendar icon
 */
const MaterialSymbolCalendarIcon: FC<IconPropsExtended> = props => (
  <MaterialSymbolIconBase {...props} iconName="calendar" />
);

export default MaterialSymbolCalendarIcon;
